export var ContentTaskType;
(function (ContentTaskType) {
    ContentTaskType[ContentTaskType["WRITE"] = 10] = "WRITE";
    ContentTaskType[ContentTaskType["UPDATE"] = 20] = "UPDATE";
    ContentTaskType[ContentTaskType["REVIEW"] = 30] = "REVIEW";
    ContentTaskType[ContentTaskType["TRANSLATE"] = 40] = "TRANSLATE";
})(ContentTaskType || (ContentTaskType = {}));
//# sourceMappingURL=content-task-type.enum.js.map